import { Button, Modal } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { MdSource } from 'react-icons/md';

export const RootStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  padding: 20,
}));

export const HeaderPageStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 32,
  marginBottom: 16,
  marginTop: theme.spacing(2),
}));

export const UploadContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 12,
  marginTop: 25,
  marginRight: 30,
  width: '30rem',
});

export const LoaderContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const BtnFolderStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.global.white,
  fontFamily: theme.typography.button,
  height: 40,
  width: 210,
  fontSize: '12px',
}));

export const LoadingProgressStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90vw',
  height: '25vh',
  gap: 16,
});

export const ContainerFolderNameStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  gap: 5,
  '& .enable': {
    backgroundColor: alpha(theme.palette.global.lightgray, 0.1),
    padding: 2,
    borderRadius: 5,
    cursor: 'pointer',
  },
  '& .folderName': {
    color: theme.palette.global.lightgray,
  },
}));

export const MainDivStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  padding: 24,
}));

export const SelectionDefaultStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  margin: '20px 20px 20px 8px',
  justifyContent: 'space-between',
  '& .typography': {
    cursor: 'pointer',
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
    '&:hover': {
      color: alpha(theme.palette.secondary.main, 0.7),
    },
  },
}));

export const DivBtnsStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  margin: '0 0 20px 0',
  '& .cancel': {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      color: alpha(theme.palette.primary.main, 0.8),
    },
  },
  '& .delete': {
    display: 'flex',
    alignItems: 'center',
    color: 'red',
    cursor: 'pointer',
    '&:hover': {
      color: alpha('#ff0000', 0.8),
    },
  },
}));

export const PreviewStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  backgroundColor: theme.palette.global.white,
  '& .image': {
    margin: 8,
    width: 135,
    height: 135,
    overflow: 'hidden',
    '&:hover': {
      cursor: 'zoom-in',
      transform: 'scale(1.1)',
    },
    '& input[type=checkbox]': {
      position: 'relative',
      top: 70,
      left: 75,
    },
  },
  '& .selectedImage': {
    margin: 8,
    width: 135,
    height: 135,
    overflow: 'hidden',
    borderWidth: '5px',
    borderStyle: 'solid',
    borderImage: `linear-gradient(to right, ${theme.palette.primary.light}, ${theme.palette.primary.dark}) 1`,
    transform: 'scale(1.1)',
  },
}));

export const DefaultPageStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 80,
  '& p': {
    color: theme.palette.global.lightgray,
    marginBottom: 40,
  },
}));

export const FolderIconStyled = styled(MdSource)(({ theme }) => ({
  color: alpha(theme.palette.global.lightgray, 0.5),
  fontSize: 150,
}));

export const ModalStyled = styled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  '& .close': {
    position: 'absolute',
    right: '5.5rem',
    top: '1.5rem',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    color: theme.palette.primary.main,
    fontSize: 38,
  },
}));
